import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

export const SelectField = ({
  onChange, value, name, placeholder, options, isDisabled, menuPlacement, menuPortalTarget
}) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '32px',
      height: '32px',
      fontSize: '0.85rem',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '30px',
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
      fontSize: '0.85rem',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '30px',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '0.85rem',
      color: '#999',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '0.85rem',
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: '0.85rem',
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    option: (provided) => ({
      ...provided,
      fontSize: '0.85rem',
      padding: '6px 10px',
    }),
  };
  return (
    <Select
      styles={customStyles}
      name={name}
      value={value}
      onChange={handleChange}
      options={options}
      clearable={false}
      className="react-select"
      placeholder={placeholder}
      classNamePrefix="react-select"
      isDisabled={isDisabled}
      menuPlacement={menuPlacement}
      menuPortalTarget={menuPortalTarget}
    />
  );
};

SelectField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object, // Allow object (including null if checked loosely, though null usually needs separate handling or not isRequired)
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
};

SelectField.defaultProps = {
  placeholder: '',
  options: [],
};

const renderSelectField = ({
  input, meta, options, placeholder, className, isDisabled, menuPlacement, menuPortalTarget
}) => (
  <div className={`form__form-group-input-wrap ${className}`}>
    <SelectField
      {...input}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      menuPlacement={menuPlacement}
      menuPortalTarget={menuPortalTarget}
    />
    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
  </div>
);

renderSelectField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

renderSelectField.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  className: '',
};

export default renderSelectField;
